var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgImplementZeroTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 380,
    viewBox: "0 0 450 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3309",
    "data-name": "Rectangle 3309",
    width: 450,
    height: 380,
    transform: "translate(-5466 -14136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7499e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00205d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35a3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9332c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c75bc",
    stopOpacity: 0.702
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15293",
    "data-name": "Path 15293",
    d: "M345.513,213.724l-17.6-21.714L310.13,207.74l34.731,39.977,68.545-60.765-16.77-17.592Z",
    transform: "translate(-310.13 -169.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15295",
    "data-name": "Path 15295",
    d: "M396.508,166.87l-50.064,44.449-18.812-21.185-17.6,15.626,34.438,38.777,67.666-60.075Z",
    transform: "translate(-310.03 -166.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e9eb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.588,
    y1: 0.077,
    x2: 0.982,
    y2: 2.304,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -32.748,
    y1: -10.811,
    x2: -32.733,
    y2: -10.818,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#caebef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3307",
    "data-name": "Rectangle 3307",
    width: 54.969,
    height: 54.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.153,
    y1: 0.113,
    x2: 0.837,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eb757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -33.363,
    y1: -15.749,
    x2: -33.351,
    y2: -15.755,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0,
    x2: 0.779,
    y2: 1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -31.047,
    y1: -16.415,
    x2: -31.038,
    y2: -16.421,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3308",
    "data-name": "Rectangle 3308",
    width: 35.406,
    height: 35.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.16,
    y1: 0.064,
    x2: 0.86,
    y2: 0.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003fb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4d54e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_implement_zero_trust",
    transform: "translate(5466 14136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK",
    "data-name": "DESIGNED BY FREEPIK",
    transform: "translate(-5432.29 -14120.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9530",
    "data-name": "Group 9530",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M69.359,253.784c36.489,75.484,133.649,117.777,217.981,106.367,13.726-1.853,51.3-7.317,84.587-33.474,64.074-50.206,77.781-149.644,26.1-219.7C360.3,55.92,292.917,27.031,228.843,28.487,215.051,28.8,162.151,30.708,115.67,64.4A161.924,161.924,0,0,0,80.211,99.717c-31.886,43.8-34.618,104.817-10.843,154.058Z",
    transform: "translate(-51.464 -8.55)",
    fill: "#e2f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M280.172,21.45a31.961,31.961,0,0,1,7.477-3.942l1.03-7.827L301.6,8.48l2.429,7.468a31.683,31.683,0,0,1,8.092,2.581l6.258-4.7,9.983,8.29-3.564,7a31.735,31.735,0,0,1,3.942,7.5l7.827,1.021,1.191,12.922-7.468,2.429a31.552,31.552,0,0,1-2.524,8.092l4.774,6.258-8.29,9.983-7-3.554a31.2,31.2,0,0,1-7.477,3.923l-1.03,7.827L295.827,86.7l-2.467-7.638a32.006,32.006,0,0,1-8.092-2.505l-6.258,4.774-9.983-8.309,3.554-6.976a31.67,31.67,0,0,1-3.923-7.5l-7.827-1.04L259.64,44.591l7.468-2.429a31.87,31.87,0,0,1,2.505-8.073l-4.7-6.258,8.281-9.964,7,3.564v.019ZM288.34,38.2a13.928,13.928,0,1,0,19.615-1.8h0a13.925,13.925,0,0,0-19.606,1.8Z",
    transform: "translate(-62.73 -7.459)",
    fill: "#45a1e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9501",
    "data-name": "Group 9501",
    transform: "translate(16.76 53.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500",
    transform: "translate(19.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3293",
    "data-name": "Rectangle 3293",
    width: 319.621,
    height: 192.958,
    rx: 1.33,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9499",
    "data-name": "Group 9499",
    transform: "translate(6.475 6.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3294",
    "data-name": "Rectangle 3294",
    width: 306.68,
    height: 177.058,
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3295",
    "data-name": "Rectangle 3295",
    width: 306.68,
    height: 8.385,
    fill: "#615efc",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9498",
    "data-name": "Group 9498",
    transform: "translate(18.944 22.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3296",
    "data-name": "Rectangle 3296",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3297",
    "data-name": "Rectangle 3297",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(32.453)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(0 29.286)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3299",
    "data-name": "Rectangle 3299",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(32.453 29.286)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3300",
    "data-name": "Rectangle 3300",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(0 58.562)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3301",
    "data-name": "Rectangle 3301",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(32.453 58.562)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3302",
    "data-name": "Rectangle 3302",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(0 87.848)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3303",
    "data-name": "Rectangle 3303",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(32.453 87.848)",
    fill: "#d7d7ff",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3304",
    "data-name": "Rectangle 3304",
    width: 19.559,
    height: 19.559,
    rx: 5.33,
    transform: "translate(0 117.125)",
    fill: "#d7d7ff",
    opacity: 0.53
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3305",
    "data-name": "Rectangle 3305",
    width: 57.4,
    height: 28.426,
    transform: "translate(131.116 192.958)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15292",
    "data-name": "Path 15292",
    d: "M308.391,297.81H201.541a9.666,9.666,0,0,0-9.661,9.661H318.052A9.666,9.666,0,0,0,308.391,297.81Z",
    transform: "translate(-95.155 -76.417)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3306",
    "data-name": "Rectangle 3306",
    width: 358.361,
    height: 1.531,
    transform: "translate(0 229.854)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M360.737,14.556a17.549,17.549,0,0,1,4.122-2.174l.567-4.33,7.137-.652,1.323,4.1a17.484,17.484,0,0,1,4.452,1.371l3.413-2.619,5.492,4.556-1.957,3.847a17.3,17.3,0,0,1,2.174,4.112l4.273.567.652,7.109-4.14,1.342a17.506,17.506,0,0,1-1.371,4.471l2.581,3.394L384.9,45.146l-3.847-1.957a17.42,17.42,0,0,1-4.112,2.155l-.567,4.282-7.118.652-1.323-4.112a17.533,17.533,0,0,1-4.443-1.371l-3.431,2.628-5.492-4.575,1.957-3.838a17.668,17.668,0,0,1-2.155-4.122l-4.282-.567-.643-7.1,4.1-1.342a18.373,18.373,0,0,1,1.39-4.443l-2.59-3.431,4.556-5.492,3.847,2.023Zm4.736,14.322a5.436,5.436,0,1,0,0-.057Z",
    transform: "translate(-67.641 -7.4)",
    fill: "#3659a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035-2",
    "data-name": "Path 6035",
    d: "M59.262,270.94a12.254,12.254,0,0,1,2.893-1.522l.4-3.034,5-.454.926,2.874a12.06,12.06,0,0,1,3.12.964l2.392-1.834,3.847,3.2-1.371,2.694a12.193,12.193,0,0,1,1.522,2.883l2.987.4.454,4.972-2.9.936a12.192,12.192,0,0,1-.964,3.138l1.806,2.373-3.2,3.847L73.479,291a12.344,12.344,0,0,1-2.883,1.513l-.4,3-4.982.454-.926-2.883a11.992,11.992,0,0,1-3.11-.964l-2.4,1.843-3.847-3.2,1.371-2.685a12.775,12.775,0,0,1-1.513-2.893l-3-.4-.454-4.972,2.874-.936a12.788,12.788,0,0,1,.974-3.11l-1.815-2.4,3.2-3.847,2.694,1.418Zm3.318,10.03a3.8,3.8,0,1,0,0-.047v.038Z",
    transform: "translate(-51.34 -21.537)",
    fill: "#1d4ca0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shield",
    transform: "translate(182.614 80.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shield_Part-2",
    "data-name": "Shield Part-2",
    d: "M459.826,118.157,352.182,92.34,244.539,118.157s-1.248,52.106,15.163,116.614,92.49,91.374,92.49,91.374,76.07-26.875,92.49-91.374,15.163-116.614,15.163-116.614h-.028Z",
    transform: "translate(-244.517 -92.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shield_Part-3",
    "data-name": "Shield Part-3",
    d: "M444.587,133.13l-91.469-21.95-91.469,21.95s-1.049,44.279,12.875,99.088,78.584,77.648,78.584,77.648,64.65-22.839,78.584-77.648,12.875-99.088,12.875-99.088h0Z",
    transform: "translate(-245.453 -93.37)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shield_Part-4",
    "data-name": "Shield Part-4",
    d: "M414.676,126.43C410.98,148.6,390.93,226.5,289.1,261.469c23.6,34.41,65.539,49.251,65.539,49.251s64.65-22.839,78.584-77.648S446.1,133.983,446.1,133.983l-31.413-7.534h-.009Z",
    transform: "translate(-246.955 -94.204)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9359",
    "data-name": "Group 9359",
    transform: "translate(61.931 70.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9356",
    "data-name": "Group 9356",
    transform: "translate(0.095 2.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9355",
    "data-name": "Group 9355",
    transform: "translate(-38.902 -51.263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3244",
    "data-name": "Rectangle 3244",
    width: 129.244,
    height: 127.155,
    transform: "matrix(0.748, -0.664, 0.664, 0.748, 0, 85.809)",
    fill: "#8799af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9358",
    "data-name": "Group 9358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15294",
    "data-name": "Path 15294",
    d: "M396.508,166.87l-50.064,44.449-18.812-21.185-17.6,15.626,34.438,38.777,67.666-60.075Z",
    transform: "translate(-310.03 -166.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9503",
    "data-name": "Group 9503",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9357",
    "data-name": "Group 9357",
    transform: "translate(-38.566 -50.731)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3245",
    "data-name": "Rectangle 3245",
    width: 127.939,
    height: 125.897,
    transform: "matrix(0.748, -0.664, 0.664, 0.748, 0, 84.943)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9526",
    "data-name": "Group 9526",
    transform: "translate(87.982 88.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9511",
    "data-name": "Group 9511",
    transform: "translate(16.519 100.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9508",
    "data-name": "Group 9508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15296",
    "data-name": "Path 15296",
    d: "M217.494,333.965s-.7,6.258-1.371,7.752-4.906,1.938-8.186.6c0,0-.454-7.288-.1-9.472l9.652,1.125Z",
    transform: "translate(-164.391 -214.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15297",
    "data-name": "Path 15297",
    d: "M184.725,333.744l-1.739,9.831a18.947,18.947,0,0,1-7.723-.907s-.548-7.874-.189-10.058l9.652,1.125Z",
    transform: "translate(-162.601 -214.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15298",
    "data-name": "Path 15298",
    d: "M206.311,208.05s19.975,42.208,22.64,50.943-2.392,53.713-6.759,68.384c0,0-5.719,3-17.536.416,0,0-1.1-48.741,2.07-63.072,0,0-16.4-18.708-18.443-30.95l-3.053-22.631,21.081-3.091Z",
    transform: "translate(-163.163 -208.05)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15299",
    "data-name": "Path 15299",
    d: "M192.641,209.709s3.611,22.773,1.7,28.7c0,0-2.155,25.628-3.129,30.118s-1.569,51.444-2,57.362c0,0-3.082,5.379-16.751,1.512,0,0-8.111-61.077-8.3-78.357-.076-6.561-2.032-13.253-2.231-18.679a61.177,61.177,0,0,1,2.032-18.311s24.682-1.475,28.681-2.354Z",
    transform: "translate(-161.886 -208.14)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505",
    transform: "translate(41.884 124.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15300",
    "data-name": "Path 15300",
    d: "M216.8,342.076s-5.02,2.363-8.29-.435c-2.2-1.881-2.25,6.116-2.014,8.952a1.339,1.339,0,0,0,1.153,1.229,55,55,0,0,0,10.03.728s10.02-.17,15.135-.17c7.581,0,6.646-1.522,6.646-1.522s-.5-4.434-7.856-5.7c-.624-.1-1.3-.189-2.014-.246a9.392,9.392,0,0,1-5.124-1.985,28.751,28.751,0,0,0-5.01-3.384c-2.023-.794-2.656,2.543-2.656,2.543Z",
    transform: "translate(-206.204 -339.421)",
    fill: "#828ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15301",
    "data-name": "Path 15301",
    d: "M234.418,345.79s-2.174,2.146-1.692,6.939c0,0,7.931.624,8.631-1.531,0,0-1.059-4.348-6.929-5.407Z",
    transform: "translate(-207.64 -339.769)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15302",
    "data-name": "Path 15302",
    d: "M239.9,351.5s-.671,1.995-13.717,1.3-17.4.293-19.71-1.56c0,0-.567,1.853,0,2.458s13.641,1.059,17.573,1.191,14.482.709,15.844-1.191a1.876,1.876,0,0,0,0-2.2Z",
    transform: "translate(-206.194 -340.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15303",
    "data-name": "Path 15303",
    d: "M227.606,344.432a7.723,7.723,0,0,0-2.477,1.683.441.441,0,0,1-.321.189c-.208.009-.51-.076-.331-.624.3-.889,2.127-1.73,2.127-1.73s.822.057,1,.482Z",
    transform: "translate(-207.189 -339.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15304",
    "data-name": "Path 15304",
    d: "M225.325,343.151a6.88,6.88,0,0,0-2.411,1.7.448.448,0,0,1-.359.208c-.227.019-.567-.076-.359-.681.331-.974,2.344-1.91,2.344-1.91a1.512,1.512,0,0,1,.785.681Z",
    transform: "translate(-207.064 -339.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15305",
    "data-name": "Path 15305",
    d: "M223.368,341.681A6.825,6.825,0,0,0,221,343.354a.461.461,0,0,1-.35.2c-.227.019-.558-.076-.359-.671.321-.964,2.307-1.881,2.307-1.881a1.468,1.468,0,0,1,.775.671Z",
    transform: "translate(-206.96 -339.507)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15306",
    "data-name": "Path 15306",
    d: "M214.49,352.14l.217-.076a8.226,8.226,0,0,0-3.176-4.263,7.739,7.739,0,0,0-5.02-1.134.405.405,0,0,0-.312.217.2.2,0,0,0,.057.2l.151-.17a.074.074,0,0,1,0,.047c0-.019.066-.057.123-.066a7.482,7.482,0,0,1,4.868,1.1,8,8,0,0,1,3.082,4.15Z",
    transform: "translate(-206.193 -339.814)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9507",
    "data-name": "Group 9507",
    transform: "translate(10.113 123.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15307",
    "data-name": "Path 15307",
    d: "M183.031,341.289s-.5-2.014-2.165-2.382c-3.129-.7-4.585.236-5.558,2.392,0,0-.028.2-.312.066a.555.555,0,0,0-.756.312,13.275,13.275,0,0,0-.662,3.743c-.132,2.931-.388,4.831-.388,4.831s10.4.406,11.571,0c.86-.3,0-5.87-.52-8.092-.189-.813-1.012-.444-1.219-.879Z",
    transform: "translate(-172.618 -338.678)",
    fill: "#828ac4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506",
    transform: "translate(0 7.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15308",
    "data-name": "Path 15308",
    d: "M185.354,351.715a5.119,5.119,0,0,0-4.178-5.209c-4.348-.832-7.61.378-8.366,5.209C172.81,351.715,179.786,355.855,185.354,351.715Z",
    transform: "translate(-172.597 -346.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15309",
    "data-name": "Path 15309",
    d: "M185.342,352.03s.662,2.411-.066,2.968c-1.56,1.172-9.964,1.891-12.469-.709-.5-1.815,0-2.259,0-2.259s7.7,2.968,12.544,0Z",
    transform: "translate(-172.584 -346.579)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15310",
    "data-name": "Path 15310",
    d: "M182.514,342.206s-3.025-1.437-5.558-.35c-1.947.832-.766,1.512-.766,1.512a7.412,7.412,0,0,1,6.872.255S183.544,342.868,182.514,342.206Z",
    transform: "translate(-172.762 -338.83)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15311",
    "data-name": "Path 15311",
    d: "M182.514,344.276s-3.025-1.437-5.558-.35c-1.947.832-.766,1.513-.766,1.513a7.412,7.412,0,0,1,6.872.255S183.544,344.938,182.514,344.276Z",
    transform: "translate(-172.762 -338.943)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510",
    transform: "translate(2.877 4.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9509",
    "data-name": "Group 9509",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15312",
    "data-name": "Path 15312",
    d: "M195.4,240.294a12.029,12.029,0,0,0,2.5-3.942,10.459,10.459,0,0,0,.369-3,36.619,36.619,0,0,0-2.533-13.717c-.076-.2-.161-.4-.236-.6a15.049,15.049,0,0,1-.983-3.044l-.265.047a15.207,15.207,0,0,0,.993,3.1c.085.2.161.4.236.6a36.443,36.443,0,0,1,2.515,13.613,9.94,9.94,0,0,1-.359,2.921,11.631,11.631,0,0,1-2.448,3.847l.208.17Z",
    transform: "translate(-166.533 -213.286)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15313",
    "data-name": "Path 15313",
    d: "M195.068,249.035c1.976-5.823-5.341-30.666-5.653-31.715l-.265.076c.076.255,7.6,25.807,5.653,31.555l.255.085Z",
    transform: "translate(-166.254 -213.359)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15314",
    "data-name": "Path 15314",
    d: "M165.873,233.384c10.295-4.982,7.468-14.359,7.44-14.454l-.255.085a11.927,11.927,0,0,1,.17,5.218c-.5,2.656-2.2,6.362-7.468,8.9l.123.246Z",
    transform: "translate(-164.975 -213.447)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15315",
    "data-name": "Path 15315",
    d: "M213.471,221.647l.085-.255c-3.866-1.3-9.132-8.2-9.189-8.262l-.217.161c.217.284,5.369,7.033,9.321,8.357Z",
    transform: "translate(-167.075 -213.13)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15316",
    "data-name": "Path 15316",
    d: "M211.066,330.559l.274-.028c-.974-8.6,3.46-61.672,3.98-65.5.539-3.923-19.039-22.725-19.871-23.519l-.189.2c.2.2,20.315,19.5,19.786,23.293-.529,3.829-4.963,56.955-3.989,65.567Z",
    transform: "translate(-166.589 -214.682)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15317",
    "data-name": "Path 15317",
    d: "M174.27,328.325l.274-.028c-.057-.633-5.785-63.525-7.071-74.056s-2.259-36.2-2.269-36.461h-.274c.009.265.983,25.958,2.269,36.489s7.014,73.413,7.071,74.047Z",
    transform: "translate(-164.93 -213.384)",
    fill: "#7d9ff5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15318",
    "data-name": "Path 15318",
    d: "M213.271,334.013a49.4,49.4,0,0,0,10.5-1.286l-.057-.217c-.113.028-11.561,2.864-17.942,0l-.095.208a19,19,0,0,0,7.581,1.3Z",
    transform: "translate(-167.158 -219.658)",
    fill: "#7d9ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15319",
    "data-name": "Path 15319",
    d: "M181,333.429a13.4,13.4,0,0,0,8.99-3.148l-.161-.161c-.066.057-6.277,6.069-16.978,1.144l-.095.208A19.625,19.625,0,0,0,181,333.438Z",
    transform: "translate(-165.358 -219.527)",
    fill: "#7d9ff5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9515",
    "data-name": "Group 9515",
    transform: "translate(19.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15320",
    "data-name": "Path 15320",
    d: "M198.92,113.39s8.205,7.7.123,10.5Z",
    transform: "translate(-166.525 -102.012)",
    fill: "#0b181b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15321",
    "data-name": "Path 15321",
    d: "M193.75,127.592a5.615,5.615,0,0,0,5.332,5.842,5.552,5.552,0,0,0,5.644-5.492,5.615,5.615,0,0,0-5.332-5.842,5.552,5.552,0,0,0-5.644,5.492Z",
    transform: "translate(-166.242 -102.488)",
    fill: "#3916a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15322",
    "data-name": "Path 15322",
    d: "M191.493,140.417l.435,10.928c.161,3.838-2.051,5.974-5.71,6.078h0c-3.129.095-6.617-1.286-6.608-4.679l.123-17.224,11.769,4.9Z",
    transform: "translate(-165.469 -103.222)",
    fill: "#ffb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15323",
    "data-name": "Path 15323",
    d: "M191.811,147.806s-8.877,1.1-12.034-8.81c-.993-3.12,11.7.425,11.7.425l.331,8.385Z",
    transform: "translate(-165.475 -103.342)",
    fill: "#0b181b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15324",
    "data-name": "Path 15324",
    d: "M188.042,142.232h0c6.239-.236,11.193-5.511,11.164-10.786l-.113-11.022a12.1,12.1,0,0,0-11.523-12.2h0c-6.542-.208-13.149,5.067-13.329,11.826l.189,8.593a13.743,13.743,0,0,0,13.613,13.6Z",
    transform: "translate(-165.175 -101.729)",
    fill: "#ffb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15325",
    "data-name": "Path 15325",
    d: "M205.342,109.116l-4.736-.671c1.38-.879,2.77-1.758,2.77-1.758a25.3,25.3,0,0,0-7.534-1.106,22.289,22.289,0,0,0-10.153-2.59c-5.5-.066-10.191,2.912-11.892,6.192h0s-4.566-.284-5.19,4.878c-.813,6.693,7.251,17.753,7.251,17.753l.907-8.744c4.991-.359,5.228-4.764,4.84-7.638,2.25.189,10,.7,16.061-.652a7.026,7.026,0,0,0,2.316-.643c2.864-.983,5-2.552,5.379-5.029Z",
    transform: "translate(-164.864 -101.443)",
    fill: "#0b181b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9512",
    "data-name": "Group 9512",
    transform: "translate(3.505 22.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15326",
    "data-name": "Path 15326",
    d: "M168.36,129.566a4.487,4.487,0,0,0,4.263,4.67,4.44,4.44,0,0,0,4.509-4.4,4.487,4.487,0,0,0-4.263-4.67A4.44,4.44,0,0,0,168.36,129.566Z",
    transform: "translate(-168.358 -125.168)",
    fill: "#ffba99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15327",
    "data-name": "Path 15327",
    d: "M174.388,131s.085-3.29-2.968-2.864",
    transform: "translate(-168.526 -125.328)",
    fill: "none",
    stroke: "#312220",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9514",
    "data-name": "Group 9514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15328",
    "data-name": "Path 15328",
    d: "M190.035,102.779l.142.633s-7.931.832-11.542,5.653c-4.027,5.369-4.093,12.62-4.093,12.62l-1.711.142.113-11.486,3.432-3.583,5.473-3.28,3.838-1.229,4.358.52Z",
    transform: "translate(-165.098 -101.403)",
    fill: "#3916a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9513",
    "data-name": "Group 9513",
    transform: "translate(0 18.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15329",
    "data-name": "Path 15329",
    d: "M178.96,126.914c.822,3.772-1.617,7.506-6.409,8.546-3.384.737-5.039-2.108-5.861-5.889s1.267-7.43,4.651-8.168,6.8,1.73,7.619,5.5Z",
    transform: "translate(-164.752 -121.272)",
    fill: "#3916a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15330",
    "data-name": "Path 15330",
    d: "M177.1,127.314c.822,3.772-1.267,7.43-4.651,8.168s-6.8-1.73-7.619-5.5,1.267-7.43,4.651-8.168,6.8,1.73,7.619,5.5Z",
    transform: "translate(-164.651 -121.295)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15331",
    "data-name": "Path 15331",
    d: "M170.2,121.495a26.912,26.912,0,0,1,.34-8.782A14.364,14.364,0,0,1,182.3,101.7c.444-.085.917-.161,1.408-.227a8.931,8.931,0,0,1,5.076.577,5.989,5.989,0,0,1,1.087.671s-7.7.321-11.41,4.443a21.279,21.279,0,0,0-5.02,15.031l-3.252-.709Z",
    transform: "translate(-164.942 -101.354)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15332",
    "data-name": "Path 15332",
    d: "M175.12,153.509l10.011,5.946,10.238-5.634s.709,6.74-9.066,7.024S175.12,153.5,175.12,153.5Z",
    transform: "translate(-165.223 -104.205)",
    fill: "#ffb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15333",
    "data-name": "Path 15333",
    d: "M185.4,135.05h7.326s.123,2.732-3.677,2.571-3.658-2.571-3.658-2.571Z",
    transform: "translate(-165.785 -103.196)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523",
    transform: "translate(0 47.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9518",
    "data-name": "Group 9518",
    transform: "translate(57.2 2.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9516",
    "data-name": "Group 9516",
    transform: "translate(2.004 38.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15334",
    "data-name": "Path 15334",
    d: "M217.618,198.476l29.333,6.182,1.579,5.88-38.408.548L207.04,195.13Z",
    transform: "translate(-207.04 -195.13)",
    fill: "#f9a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15335",
    "data-name": "Path 15335",
    d: "M244.295,204.7s5.993-3.639,11.939-2.118c3.923,1,7.8,4.774,7.506,8.8h0l-23.86-.3,4.415-6.381Z",
    transform: "translate(-208.836 -195.517)",
    fill: "#f9a498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9517",
    "data-name": "Group 9517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15336",
    "data-name": "Path 15336",
    d: "M219.175,176.24l3.384,25.117s-14.662,7.714-14.35,6.787-3.29-31.9-3.29-31.9h14.255Z",
    transform: "translate(-204.92 -155.462)",
    fill: "#f9a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15337",
    "data-name": "Path 15337",
    d: "M206.15,154.26s10.758,1.692,13.216,10.881c3.2,11.968,4.415,13.7,4.415,13.7L207.511,181.2Z",
    transform: "translate(-204.987 -154.26)",
    fill: "#804a9c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15338",
    "data-name": "Path 15338",
    d: "M178.508,151.86s-2.458,6.05,5.662,6.882,6.258-6.882,6.258-6.882l13.1,2.269a4.3,4.3,0,0,1,3.677,4.216l-.246,56.88-46.15.132-2.392-50.612,1.711-5.8a7.344,7.344,0,0,1,5.889-5.171l12.478-1.91Z",
    transform: "translate(-145.177 -151.86)",
    fill: "#804a9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9522",
    "data-name": "Group 9522",
    transform: "translate(0 0.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9519",
    "data-name": "Group 9519",
    transform: "translate(1.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15339",
    "data-name": "Path 15339",
    d: "M168.659,181.174l-8.64,23.6L146.69,192.518l5.18-16.978Z",
    transform: "translate(-146.019 -154.015)",
    fill: "#ffb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15340",
    "data-name": "Path 15340",
    d: "M177.034,152.77s-16.061-.151-20.06,4.859c-5.029,6.305-10.994,22.432-10.994,22.432L172.1,186.14l4.925-33.37Z",
    transform: "translate(-145.98 -152.769)",
    fill: "#804a9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9521",
    "data-name": "Group 9521",
    transform: "translate(0 39.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9520",
    "data-name": "Group 9520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15341",
    "data-name": "Path 15341",
    d: "M161.388,202.054l30.146,6.712L190.3,215.44l-35.62.236s-15.929-3.214-8.1-21.5l14.823,7.874Z",
    transform: "translate(-144.411 -194.18)",
    fill: "#ffb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15342",
    "data-name": "Path 15342",
    d: "M194.007,209.508s7.08-2.77,12.951-1.673a8.052,8.052,0,0,1,6.353,8.583h0l-23.671-.208,4.367-6.693Z",
    transform: "translate(-146.885 -194.913)",
    fill: "#ffb0a0"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 7.44,
    y1: 1.03,
    transform: "translate(9.537 6.844)",
    fill: "none",
    stroke: "#e98980",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9525",
    "data-name": "Group 9525",
    transform: "translate(30.296 71.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15343",
    "data-name": "Path 15343",
    d: "M178.341,219.832h33.313V216.07H178.341a1.88,1.88,0,0,0-1.881,1.881h0a1.88,1.88,0,0,0,1.881,1.881Z",
    transform: "translate(-176.46 -179.335)",
    fill: "#061418"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9524",
    "data-name": "Group 9524",
    transform: "translate(30.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15344",
    "data-name": "Path 15344",
    d: "M209.04,217.707h47.824a5.658,5.658,0,0,0,5.454-4.141l8.6-30.921a4.289,4.289,0,0,0-4.131-5.436H222.568A3.74,3.74,0,0,0,218.956,180l-9.916,37.718Z",
    transform: "translate(-209.04 -177.21)",
    fill: "#1c2e34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15345",
    "data-name": "Path 15345",
    d: "M239.42,200.208a4.178,4.178,0,1,0,4.178-4.178A4.18,4.18,0,0,0,239.42,200.208Z",
    transform: "translate(-210.701 -178.239)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9497",
    "data-name": "Group 9497",
    transform: "translate(-5420.911 -14105.205) rotate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15289",
    "data-name": "Path 15289",
    d: "M3.274,3.949a1.214,1.214,0,0,1-.729-.237C1.877,3.233,1.2,2.747.525,2.267A1.248,1.248,0,0,1,1.965.229Q2.993.958,4,1.687a1.246,1.246,0,0,1-.729,2.256Z",
    transform: "translate(402.948 76.947)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15290",
    "data-name": "Path 15290",
    d: "M327.2,198.928h0c-1.658,0-3.334-.012-5.017-.037a1.246,1.246,0,0,1-1.228-1.265,1.267,1.267,0,0,1,1.265-1.228q2.505.037,4.986.037a1.246,1.246,0,1,1,0,2.493Zm6.251-.037a1.246,1.246,0,0,1-.019-2.493q2.505-.037,4.986-.1a1.244,1.244,0,1,1,.069,2.487c-1.658.044-3.334.081-5.017.106h-.019Zm-17.494-.131h-.037q-2.5-.075-5.011-.168a1.247,1.247,0,0,1,.05-2.493h.05q2.505.1,4.979.168a1.247,1.247,0,0,1-.037,2.493Zm28.742-.193a1.247,1.247,0,0,1-.056-2.493q2.505-.112,4.973-.255a1.246,1.246,0,1,1,.15,2.487q-2.487.15-5.011.262Zm-39.979-.268h-.069q-2.487-.131-5-.293a1.246,1.246,0,0,1,.156-2.487q2.505.159,4.979.293a1.244,1.244,0,0,1-.069,2.487Zm51.209-.424a1.245,1.245,0,0,1-.093-2.487q2.505-.2,4.961-.43a1.246,1.246,0,1,1,.237,2.48q-2.477.234-5,.436h-.1Zm-62.433-.312h-.1q-2.487-.187-4.992-.411a1.245,1.245,0,1,1,.218-2.48q2.5.215,4.973.405a1.248,1.248,0,0,1-.093,2.493Zm73.632-.779a1.248,1.248,0,0,1-.143-2.487c1.67-.193,3.334-.405,4.936-.623a1.245,1.245,0,1,1,.337,2.468c-1.62.218-3.3.43-4.986.63-.05,0-.1.006-.143.006Zm-84.838-.206h-.125c-1.658-.162-3.315-.337-4.986-.517a1.248,1.248,0,0,1,.274-2.48c1.658.181,3.316.355,4.961.517a1.246,1.246,0,0,1-.125,2.487Zm-11.18-1.234a1.2,1.2,0,0,1-.15-.006q-2.477-.3-4.973-.623a1.247,1.247,0,1,1,.318-2.474c1.658.218,3.3.424,4.948.623a1.248,1.248,0,0,1-.143,2.487Zm107.161-.1a1.245,1.245,0,0,1-.193-2.474c1.652-.268,3.3-.548,4.9-.841a1.248,1.248,0,1,1,.449,2.455c-1.62.3-3.291.586-4.955.854a1.081,1.081,0,0,1-.2.019ZM259.96,193.88a.821.821,0,0,1-.175-.012c-1.645-.231-3.3-.474-4.961-.723a1.248,1.248,0,1,1,.374-2.468c1.652.249,3.3.486,4.936.723a1.246,1.246,0,0,1-.174,2.48Zm129.372-.7a1.244,1.244,0,0,1-.256-2.462c1.627-.349,3.259-.717,4.842-1.1a1.246,1.246,0,0,1,.58,2.424c-1.608.386-3.259.76-4.911,1.116a1.242,1.242,0,0,1-.262.025Zm-140.49-.991a.721.721,0,0,1-.2-.019q-2.468-.4-4.942-.823a1.248,1.248,0,0,1,.418-2.462q2.468.421,4.923.816a1.245,1.245,0,0,1-.2,2.474Zm151.421-1.683a1.244,1.244,0,0,1-.337-2.443c1.614-.449,3.216-.922,4.755-1.4a1.248,1.248,0,0,1,.748,2.381c-1.57.492-3.191.972-4.83,1.427a1.247,1.247,0,0,1-.337.044Zm-162.508-.218a1.366,1.366,0,0,1-.224-.019q-2.459-.449-4.923-.916a1.247,1.247,0,1,1,.467-2.449q2.459.467,4.9.91a1.247,1.247,0,0,1-.224,2.474Zm-11.043-2.113a1.163,1.163,0,0,1-.249-.025q-2.44-.5-4.9-1.01a1.248,1.248,0,0,1,.511-2.443c1.627.343,3.253.673,4.88,1a1.249,1.249,0,0,1-.243,2.474Zm184.265-1.072a1.246,1.246,0,0,1-.424-2.418c1.57-.567,3.129-1.165,4.618-1.776a1.248,1.248,0,1,1,.941,2.312c-1.527.623-3.11,1.234-4.711,1.814a1.24,1.24,0,0,1-.424.075ZM215.718,185.86a.984.984,0,0,1-.268-.031q-2.44-.533-4.88-1.1a1.247,1.247,0,0,1,.561-2.431q2.431.561,4.861,1.091a1.246,1.246,0,0,1-.268,2.462Zm-10.956-2.518a1.219,1.219,0,0,1-.293-.037c-1.627-.393-3.253-.785-4.867-1.19a1.245,1.245,0,1,1,.6-2.418c1.608.4,3.228.8,4.849,1.184a1.248,1.248,0,0,1-.287,2.462Zm216.59-.549a1.249,1.249,0,0,1-.542-2.374c1.514-.723,2.992-1.477,4.394-2.237a1.245,1.245,0,1,1,1.19,2.187c-1.44.785-2.96,1.558-4.512,2.3a1.272,1.272,0,0,1-.536.125Zm-227.509-2.175a1.328,1.328,0,0,1-.312-.037c-1.62-.418-3.234-.847-4.842-1.277a1.246,1.246,0,0,1,.648-2.406q2.4.645,4.824,1.271a1.248,1.248,0,0,1-.312,2.455ZM182.981,177.7a1.05,1.05,0,0,1-.337-.05c-1.614-.449-3.222-.91-4.817-1.365a1.249,1.249,0,0,1,.692-2.4c1.6.461,3.191.916,4.8,1.365a1.244,1.244,0,0,1-.337,2.443Zm248.194-.362a1.247,1.247,0,0,1-.679-2.293c1.4-.91,2.748-1.857,4.014-2.823a1.245,1.245,0,0,1,1.508,1.982c-1.309,1-2.711,1.982-4.163,2.929a1.232,1.232,0,0,1-.679.2Zm-259-2.761a1.482,1.482,0,0,1-.361-.05q-2.412-.72-4.793-1.458a1.246,1.246,0,0,1,.735-2.381c1.583.492,3.172.972,4.774,1.452a1.248,1.248,0,0,1-.355,2.443Zm-10.744-3.334a1.155,1.155,0,0,1-.38-.062q-2.393-.767-4.761-1.552a1.247,1.247,0,1,1,.785-2.368c1.57.523,3.153,1.035,4.743,1.546a1.249,1.249,0,0,1-.38,2.437Zm278.588-.81a1.246,1.246,0,0,1-.86-2.15,47.774,47.774,0,0,0,3.353-3.521,1.246,1.246,0,1,1,1.894,1.62,49.014,49.014,0,0,1-3.527,3.708A1.237,1.237,0,0,1,440.018,170.429Zm-289.269-2.736a1.317,1.317,0,0,1-.405-.069c-1.589-.542-3.166-1.1-4.73-1.652a1.246,1.246,0,1,1,.829-2.349c1.558.555,3.129,1.1,4.711,1.639a1.246,1.246,0,0,1-.405,2.424Zm-10.6-3.764a1.3,1.3,0,0,1-.43-.075q-2.365-.869-4.7-1.745a1.249,1.249,0,0,1,.885-2.337c1.546.586,3.11,1.165,4.674,1.739a1.247,1.247,0,0,1-.43,2.418Zm307-2.144a1.243,1.243,0,0,1-1.053-1.9,34.864,34.864,0,0,0,2.262-4.25,1.246,1.246,0,1,1,2.275,1.016,38.507,38.507,0,0,1-2.424,4.549A1.241,1.241,0,0,1,447.148,161.785ZM129.628,159.94a1.307,1.307,0,0,1-.455-.087q-2.346-.916-4.662-1.851a1.246,1.246,0,0,1,.929-2.312c1.533.617,3.079,1.234,4.637,1.839a1.246,1.246,0,0,1-.455,2.406ZM119.2,155.721a1.183,1.183,0,0,1-.48-.1q-2.328-.972-4.618-1.957a1.248,1.248,0,1,1,.985-2.293c1.521.654,3.048,1.3,4.593,1.944a1.247,1.247,0,0,1-.48,2.4ZM451.523,151.5a1.229,1.229,0,0,1-.3-.037,1.252,1.252,0,0,1-.916-1.508l.069-.28a33.769,33.769,0,0,0,.742-4.468,1.246,1.246,0,0,1,2.48.237,36.53,36.53,0,0,1-.792,4.8l-.075.3a1.244,1.244,0,0,1-1.209.947Zm-342.654-.23a1.309,1.309,0,0,1-.5-.106c-1.533-.685-3.06-1.377-4.568-2.069a1.245,1.245,0,0,1,1.041-2.262q2.253,1.038,4.543,2.057a1.248,1.248,0,0,1-.511,2.387Zm-10.214-4.712a1.184,1.184,0,0,1-.536-.125q-2.281-1.084-4.512-2.187A1.247,1.247,0,0,1,94.71,142q2.225,1.094,4.487,2.175a1.249,1.249,0,0,1-.542,2.374Zm-10.09-4.979a1.227,1.227,0,0,1-.567-.137q-2.253-1.15-4.45-2.312a1.248,1.248,0,0,1,1.165-2.206c1.458.773,2.935,1.533,4.425,2.3a1.246,1.246,0,0,1-.567,2.356Zm363.849-1.241a1.249,1.249,0,0,1-1.24-1.153,38.223,38.223,0,0,0-.679-4.792,1.247,1.247,0,1,1,2.443-.5,40.6,40.6,0,0,1,.717,5.1,1.253,1.253,0,0,1-1.147,1.34h-.1ZM78.625,136.308a1.208,1.208,0,0,1-.6-.156q-2.216-1.215-4.381-2.449a1.248,1.248,0,0,1,1.234-2.169q2.15,1.225,4.35,2.43a1.249,1.249,0,0,1-.6,2.343Zm-9.772-5.578a1.238,1.238,0,0,1-.636-.175q-2.178-1.29-4.3-2.593a1.246,1.246,0,0,1,1.3-2.125q2.1,1.29,4.263,2.574a1.246,1.246,0,0,1-.636,2.318Zm381.2-1.353a1.251,1.251,0,0,1-1.178-.835c-.517-1.49-1.134-3.016-1.82-4.531a1.248,1.248,0,0,1,2.275-1.028c.717,1.583,1.359,3.178,1.9,4.743a1.254,1.254,0,0,1-.767,1.589,1.188,1.188,0,0,1-.411.069ZM59.28,124.823a1.212,1.212,0,0,1-.673-.2c-1.415-.91-2.823-1.838-4.2-2.761a1.244,1.244,0,1,1,1.384-2.069c1.359.91,2.761,1.832,4.163,2.73a1.246,1.246,0,0,1-.673,2.293Zm386.048-5.634a1.254,1.254,0,0,1-1.084-.623c-.791-1.377-1.664-2.786-2.593-4.182a1.245,1.245,0,0,1,2.075-1.377c.96,1.44,1.857,2.892,2.674,4.319a1.251,1.251,0,0,1-1.078,1.87Zm-395.383-.654a1.226,1.226,0,0,1-.717-.231c-1.371-.966-2.742-1.957-4.076-2.935a1.248,1.248,0,1,1,1.483-2.007c1.321.972,2.68,1.951,4.038,2.91a1.249,1.249,0,0,1-.723,2.268Zm-9.037-6.7a1.267,1.267,0,0,1-.767-.262c-1.34-1.047-2.661-2.106-3.926-3.147A1.246,1.246,0,0,1,37.8,106.5c1.253,1.028,2.555,2.075,3.876,3.1a1.249,1.249,0,0,1-.773,2.231Zm398.144-1.97a1.257,1.257,0,0,1-.991-.486c-.978-1.271-2.019-2.561-3.1-3.839a1.247,1.247,0,1,1,1.9-1.614c1.109,1.309,2.175,2.63,3.178,3.932a1.242,1.242,0,0,1-.231,1.745,1.229,1.229,0,0,1-.76.256Zm-406.807-5.2a1.223,1.223,0,0,1-.823-.312c-1.271-1.122-2.53-2.256-3.733-3.384a1.248,1.248,0,1,1,1.708-1.82c1.184,1.109,2.418,2.231,3.677,3.334a1.246,1.246,0,0,1-.823,2.181Zm399.5-3.347a1.252,1.252,0,0,1-.91-.393c-1.1-1.178-2.268-2.368-3.459-3.546a1.247,1.247,0,1,1,1.751-1.776c1.209,1.2,2.4,2.412,3.521,3.608a1.246,1.246,0,0,1-.91,2.1ZM24.063,96.94a1.241,1.241,0,0,1-.891-.374c-1.2-1.222-2.362-2.449-3.471-3.664a1.248,1.248,0,0,1,1.845-1.683c1.084,1.19,2.225,2.4,3.4,3.6a1.243,1.243,0,0,1-.885,2.119Zm399.652-3.5a1.253,1.253,0,0,1-.841-.324c-1.19-1.084-2.437-2.194-3.714-3.291a1.246,1.246,0,1,1,1.627-1.888c1.3,1.116,2.561,2.237,3.77,3.34a1.247,1.247,0,0,1-.841,2.169ZM16.547,88.583a1.23,1.23,0,0,1-.966-.461c-1.091-1.334-2.131-2.68-3.1-4a1.248,1.248,0,1,1,2.013-1.477c.947,1.284,1.963,2.6,3.023,3.9a1.247,1.247,0,0,1-.966,2.032Zm398.624-2.456a1.227,1.227,0,0,1-.779-.274c-1.265-1.016-2.58-2.05-3.908-3.066A1.245,1.245,0,1,1,412,80.811c1.346,1.035,2.674,2.075,3.957,3.1a1.249,1.249,0,0,1-.785,2.219ZM9.959,79.466a1.239,1.239,0,0,1-1.053-.586c-.916-1.458-1.776-2.935-2.561-4.387a1.245,1.245,0,1,1,2.194-1.178c.754,1.4,1.583,2.829,2.474,4.238a1.245,1.245,0,0,1-.393,1.72A1.23,1.23,0,0,1,9.959,79.466ZM4.768,69.519a1.248,1.248,0,0,1-1.153-.773c-.661-1.608-1.24-3.222-1.72-4.8a1.245,1.245,0,1,1,2.381-.729c.455,1.508,1.01,3.047,1.645,4.581a1.248,1.248,0,0,1-.679,1.627,1.282,1.282,0,0,1-.474.093ZM1.689,58.763A1.245,1.245,0,0,1,.462,57.709,39,39,0,0,1,0,52.58,1.25,1.25,0,0,1,1.216,51.3h.031a1.248,1.248,0,0,1,1.246,1.215,37.4,37.4,0,0,0,.436,4.8,1.246,1.246,0,0,1-1.041,1.421,1,1,0,0,1-.193.012ZM1.639,47.57a1.039,1.039,0,0,1-.193-.012A1.246,1.246,0,0,1,.406,46.136c.143-.929.324-1.863.542-2.773.181-.76.386-1.521.617-2.269a1.246,1.246,0,0,1,2.381.735c-.212.692-.405,1.4-.573,2.106-.2.848-.368,1.714-.5,2.58a1.245,1.245,0,0,1-1.228,1.059ZM5.111,36.932a1.227,1.227,0,0,1-.567-.137,1.243,1.243,0,0,1-.536-1.676,39.873,39.873,0,0,1,2.661-4.412,1.245,1.245,0,0,1,2.044,1.421A37.38,37.38,0,0,0,6.22,36.265a1.236,1.236,0,0,1-1.109.673Zm6.506-9.124a1.229,1.229,0,0,1-.848-.337,1.249,1.249,0,0,1-.062-1.764c1.128-1.215,2.368-2.412,3.671-3.565a1.245,1.245,0,1,1,1.645,1.87,47.646,47.646,0,0,0-3.5,3.4,1.248,1.248,0,0,1-.91.4ZM20.1,20.454a1.246,1.246,0,0,1-.723-2.262c1.34-.96,2.767-1.9,4.238-2.8a1.246,1.246,0,0,1,1.3,2.125c-1.421.872-2.8,1.782-4.094,2.711a1.245,1.245,0,0,1-.723.231Zm9.616-5.815a1.244,1.244,0,0,1-.573-2.349c1.458-.754,2.991-1.5,4.556-2.206a1.248,1.248,0,0,1,1.028,2.275c-1.527.692-3.023,1.415-4.443,2.15a1.252,1.252,0,0,1-.573.137Zm10.258-4.6a1.234,1.234,0,0,1-1.159-.8,1.247,1.247,0,0,1,.71-1.614c1.527-.592,3.122-1.178,4.736-1.739a1.246,1.246,0,1,1,.81,2.356c-1.583.548-3.147,1.122-4.649,1.708A1.275,1.275,0,0,1,39.973,10.04ZM50.618,6.407a1.248,1.248,0,0,1-.361-2.443c1.57-.467,3.2-.929,4.849-1.365a1.248,1.248,0,1,1,.642,2.412c-1.627.43-3.228.885-4.774,1.346a1.165,1.165,0,0,1-.355.05ZM61.493,3.553a1.247,1.247,0,0,1-.28-2.462C62.82.723,64.472.362,66.129.025a1.247,1.247,0,0,1,.5,2.443c-1.633.33-3.272.686-4.855,1.053A1.431,1.431,0,0,1,61.493,3.553Z",
    transform: "translate(0 1.606)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15291",
    "data-name": "Path 15291",
    d: "M1.246,2.9A1.246,1.246,0,0,1,1.035.428C1.851.285,2.68.148,3.509.017a1.244,1.244,0,1,1,.4,2.455c-.823.131-1.633.268-2.443.411a1.275,1.275,0,0,1-.212.019Z",
    transform: "translate(71.464 0)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Board_2",
    "data-name": "Board 2",
    transform: "translate(-5335.237 -14120.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Board_2_Part",
    "data-name": "Board 2 Part",
    d: "M145.943,14.43h64.272a6.164,6.164,0,0,1,6.163,6.163V78.666a6.164,6.164,0,0,1-6.163,6.163H145.943a6.164,6.164,0,0,1-6.163-6.163V20.6a6.164,6.164,0,0,1,6.163-6.163Z",
    transform: "translate(-139.78 -14.421)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Board_2_Part-2",
    "data-name": "Board 2 Part-2",
    d: "M220.731,14.42H215.9a6.667,6.667,0,0,1,6.668,6.668h0V78.141a6.646,6.646,0,0,1-6.622,6.668h4.8a6.667,6.667,0,0,0,6.668-6.668h0V21.088a6.689,6.689,0,0,0-6.686-6.668Z",
    transform: "translate(-145.988 -14.42)",
    fill: "#7ebde0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9527",
    "data-name": "Group 9527",
    transform: "translate(10.994 5.511)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cdp",
    "data-name": "ic cdp",
    transform: "translate(0.01 4.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9351",
    "data-name": "Group 9351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_301",
    "data-name": "Union 301",
    d: "M170.138,71.211A1.2,1.2,0,0,1,168.944,70h0V58.655a1.213,1.213,0,0,1,1.194-1.212h.992V55.964a8,8,0,0,1,15.99-.285v1.763h.992a1.207,1.207,0,0,1,1.194,1.212V70a1.207,1.207,0,0,1-1.194,1.212H170.138Zm7.788-8.11v2.452a1.194,1.194,0,1,0,2.388,0h0V63.1a1.194,1.194,0,0,0-2.388,0Zm-4.409-7.136v1.479h11.2V55.964a5.6,5.6,0,1,0-11.2-.239Zm19.2,6.677a2.353,2.353,0,0,1,1.984-2.673h0a8.35,8.35,0,0,0-1.295-16.605H192.6a2.356,2.356,0,0,1-2.351-2.351,11.126,11.126,0,0,0-11.113-11.131h-.018A11.161,11.161,0,0,0,167.98,41.012a2.356,2.356,0,0,1-2.351,2.351h-.8a8.355,8.355,0,0,0-1.3,16.615,2.353,2.353,0,0,1,1.984,2.673h0a2.377,2.377,0,0,1-2.333,2.011,1.455,1.455,0,0,1-.349-.028,13.073,13.073,0,0,1,.606-25.918A15.869,15.869,0,0,1,179.12,25.16h.009a15.847,15.847,0,0,1,15.678,13.565,13.072,13.072,0,0,1,.6,25.918,2.357,2.357,0,0,1-2.691-1.984h0Z",
    transform: "translate(-151.761 -25.16)",
    fill: "url(#linear-gradient-11)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Board_1",
    "data-name": "Board 1",
    transform: "translate(-5446.166 -14048.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Board_1_Part",
    "data-name": "Board 1 Part"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Board_1_Part-2",
    "data-name": "Board 1 Part-2",
    width: 71.574,
    height: 53.049,
    rx: 3.4,
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Board_1_Part-3",
    "data-name": "Board 1 Part-3",
    d: "M77.111,95.62h-2.8a3.324,3.324,0,0,1,3.325,3.325v46.4a3.324,3.324,0,0,1-3.325,3.325h2.8a3.324,3.324,0,0,0,3.325-3.325v-46.4A3.324,3.324,0,0,0,77.111,95.62Z",
    transform: "translate(-6.061 -95.62)",
    fill: "#7ebde0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_302",
    "data-name": "Union 302",
    d: "M26.409,136.839a1.67,1.67,0,0,1-1.7-1.635v-15.32a1.67,1.67,0,0,1,1.7-1.635h1.405v-1.984A11.193,11.193,0,0,1,39.2,105.3a11.193,11.193,0,0,1,11.389,10.966v1.993H52a1.67,1.67,0,0,1,1.7,1.635h0v15.32a1.67,1.67,0,0,1-1.7,1.635H26.418Zm11.086-10.948v3.316a1.705,1.705,0,0,0,3.407,0v-3.316a1.705,1.705,0,0,0-3.407,0Zm9.69-7.641v-1.984a7.987,7.987,0,0,0-15.962,0v1.993H47.184Z",
    transform: "translate(-2.015 -96.409)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531",
    transform: "translate(-5422.048 -13959.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Board_3",
    "data-name": "Board 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Board_3_Part",
    "data-name": "Board 3 Part",
    width: 78.435,
    height: 55.933,
    rx: 2.94,
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Board_3_Part-2",
    "data-name": "Board 3 Part-2",
    d: "M129.787,189.81H126.83a3.514,3.514,0,0,1,3.508,3.508v48.925a3.514,3.514,0,0,1-3.508,3.508h2.957a3.514,3.514,0,0,0,3.508-3.508V193.318A3.514,3.514,0,0,0,129.787,189.81Z",
    transform: "translate(-51.913 -189.81)",
    fill: "#7ebde0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9528",
    "data-name": "Group 9528",
    transform: "translate(20.196 10.489)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_passwordless_access",
    "data-name": "ic passwordless access",
    transform: "translate(0.097 0.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fingerprint-svgrepo-com",
    d: "M78.078,203.4a16.7,16.7,0,0,1,23.641,18.69,1.649,1.649,0,0,1-3.215-.735,13.39,13.39,0,0,0-18.957-14.989,1.654,1.654,0,1,1-1.534-2.93.23.23,0,0,0,.064-.037h0Zm-3.628,4.574a1.653,1.653,0,0,1,.312,2.314,13.371,13.371,0,0,0-2.4,5.134,59.243,59.243,0,0,1-1.782,6.383,1.653,1.653,0,1,1-3.15-1l.028-.083a54.74,54.74,0,0,0,1.681-6.025,16.577,16.577,0,0,1,2.985-6.4,1.653,1.653,0,0,1,2.314-.312Zm.569,8.046a10.672,10.672,0,0,1,20.2-1.892,1.653,1.653,0,0,1-3.031,1.323h0a7.377,7.377,0,0,0-13.951,1.3c-.386,1.69-.781,3.215-1.194,4.62a1.648,1.648,0,1,1-3.159-.937c.395-1.332.771-2.783,1.139-4.418h0Zm7.816-1.506a4.656,4.656,0,0,1,7.136,4.9q-.648,2.907-1.506,5.759a1.648,1.648,0,0,1-3.169-.909.083.083,0,0,1,.009-.046c.514-1.708.992-3.536,1.451-5.529a1.358,1.358,0,0,0-1.029-1.626,1.379,1.379,0,0,0-1.056.193,1.654,1.654,0,0,1-1.846-2.746h0ZM94.6,218.773a1.645,1.645,0,0,1,1.24,1.975A70.518,70.518,0,0,1,91.046,235.3a1.655,1.655,0,0,1-2.994-1.405A67.024,67.024,0,0,0,92.617,220a1.638,1.638,0,0,1,1.975-1.24h0Zm-12.7,1.479a1.646,1.646,0,0,1,1.139,2.039h0a47.994,47.994,0,0,1-4.252,10.553c-.129.23-.257.45-.386.68a1.651,1.651,0,0,1-2.856-1.653c.119-.211.239-.422.349-.625a44.248,44.248,0,0,0,3.958-9.855,1.658,1.658,0,0,1,2.039-1.139h0Zm-7.678,4.4a1.65,1.65,0,0,1,.845,2.177c-.478,1.093-.992,2.112-1.534,3.1a1.651,1.651,0,0,1-2.884-1.607c.5-.9.964-1.828,1.405-2.829a1.65,1.65,0,0,1,2.177-.845h0Zm25.009.652a1.651,1.651,0,0,1,1.139,2.039h0c-.542,1.9-1.148,3.775-1.837,5.63a1.653,1.653,0,1,1-3.114-1.111.07.07,0,0,1,.018-.046c.643-1.727,1.222-3.518,1.754-5.382a1.651,1.651,0,0,1,2.039-1.139h0Zm-13.666,3.371a1.65,1.65,0,0,1,.882,2.168,49.972,49.972,0,0,1-2.4,4.941,1.651,1.651,0,1,1-2.939-1.506,1,1,0,0,1,.055-.1,45.33,45.33,0,0,0,2.232-4.611,1.639,1.639,0,0,1,2.158-.882h0Z",
    transform: "translate(-67.355 -201.688)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-15)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgImplementZeroTrust);
export default __webpack_public_path__ + "static/media/img_implement_zero_trust.b5a9ca5d0f9852a65f3d5436455fff86.svg";
export { ForwardRef as ReactComponent };